import { memo } from 'react';

import { InputNumber, InputNumberProps } from 'antd';

const Number: React.FC<InputNumberProps> = ({ ...props }) => {
  return <InputNumber {...props} />;
};

export default memo(Number);
